enum Route {
  BASE = '/',
  GAME = '/game',
}

export default Route;
